import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/auth.context";
import { Permission } from "common/build/prisma/client";
import Spinner from "../layout/Spinner";

type BaseRouteProps = {
    permission?: Permission;
    layout?: React.ComponentType<{ children: React.ReactNode }>;
    component: React.ComponentType<Record<string, unknown>>;
};

/**
 * Route guard component for admin routes with authentication and permission checks
 * Migrated to React Router v6 pattern
 */
export const BaseRoute: React.FC<BaseRouteProps> = ({ permission, layout: Layout, component: Component }) => {
    const { isAuthenticated, isAuthenticating, hasPermission } = useAuth();

    // Handle authentication check
    if (permission) {
        if (!isAuthenticated) {
            if (isAuthenticating) {
                return <Spinner />;
            }
            return <Navigate to="/login" replace />;
        }

        // Handle permission check
        if (!hasPermission(permission)) {
            return <Navigate to="/403" replace />;
        }
    }

    // Render the component with optional layout wrapper
    return (
        <>
            {Layout ? (
                <Layout>
                    <Component />
                </Layout>
            ) : (
                <Component />
            )}
        </>
    );
};
